/* eslint-disable @typescript-eslint/camelcase */
import { VideoTrackerPlayerTime, VideoTrackerPlayerTimeProduct } from '@/scripts/models/VideoPagePlayerOptions';

const initAttributes = (videoId: string, product: VideoTrackerPlayerTimeProduct): VideoTrackerPlayerTime => ({
  user_id: null,
  activity_type: 'player_time',
  params: {
    buffering_duration: 0,
    isPlayerError: false,
    vimeo_loaded_time: 0,
    source: '',
    original_source: '',
    total_time_play: 0.0,
    hosted_loaded_time: 0.0,
    failOver: false,
    isHostedFailover: false,
    re_buffering_count: 0,
    source_time: 0.0,
    video_id: videoId,
    isPlayerPause: false,
    product,
    total_time: 0.0,
  },
});

export class PlayerTime {
  attributes: VideoTrackerPlayerTime;

  constructor(
    public videoId: string,
    public product: VideoTrackerPlayerTimeProduct = VideoTrackerPlayerTimeProduct.Player,
  ) {
    this.attributes = initAttributes(this.videoId, this.product);
  }
};
